import type { VatDeclarationSnapshotSummary } from '../../models.ts';
import type { VatReturnDraftPeriod, VatReturnPeriod } from '../types/index.ts';

export function vatReturnPeriodKey(periodStart: string, periodEnd: string): string {
    return `${periodStart}_${periodEnd}`;
}

function compareNewestPeriodFirst(a: VatReturnPeriod, b: VatReturnPeriod): number {
    return b.periodStart.localeCompare(a.periodStart) || a.periodEnd.localeCompare(b.periodEnd);
}

export function groupVatReturnPeriods(
    snapshots: VatDeclarationSnapshotSummary[],
    drafts: VatReturnDraftPeriod[],
): VatReturnPeriod[] {
    const periods = new Map<string, VatReturnPeriod>();

    function periodFor(periodStart: string, periodEnd: string): VatReturnPeriod {
        const key = vatReturnPeriodKey(periodStart, periodEnd);
        const existing = periods.get(key);
        if (existing) {
            return existing;
        }
        const period: VatReturnPeriod = {
            key,
            periodStart,
            periodEnd,
            versions: [],
            latestVersion: null,
            hasDraft: false,
        };
        periods.set(key, period);
        return period;
    }

    for (const snapshot of snapshots) {
        periodFor(snapshot.period_start, snapshot.period_end).versions.push(snapshot);
    }
    for (const draft of drafts) {
        periodFor(draft.dateFrom, draft.dateTo).hasDraft = true;
    }

    const grouped = [...periods.values()];
    for (const period of grouped) {
        period.versions.sort((a, b) => b.version - a.version);
        period.latestVersion = period.versions[0] ?? null;
    }
    return grouped.sort(compareNewestPeriodFirst);
}
